import { Pane } from 'evergreen-ui'

type Props = {
  dark?: boolean
  rowHeight?: number
  rows?: number
  marginLeft?: number
}

const widths = [90, 60, 77, 40]

export default function ListLoader(props: Props) {
  const { dark, rows = 14, rowHeight = 24, ...rest } = props

  const rowProps = {
    borderRadius: 6,
    className: dark ? 'shimmering-dark' : 'shimmering',
    height: rowHeight,
    marginY: rows === 1 ? 0 : 16,
  }

  return (
    <Pane width="100%" {...rest}>
      {Array(rows)
        .fill(rowProps)
        .map((row, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Pane key={`row-${i}`} {...row} width={`${widths[i % widths.length]}%`} />
        ))}
    </Pane>
  )
}
